module.exports = __webpack_public_path__ + "static/media/wine-glass.e28fb404.png";